import { render, staticRenderFns } from "./SystemStatus.vue?vue&type=template&id=bc2e6d26&"
import script from "./SystemStatus.vue?vue&type=script&lang=js&"
export * from "./SystemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports